// src/components/Header.jsx — ohapotato v2026.10.36
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';
import UserMenu from './UserMenu';

const SunIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);
const MoonIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const PotatoMark = () => (
  <svg width="30" height="30" viewBox="0 0 64 64" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="var(--accent-orange)"/>
    <ellipse cx="32" cy="35" rx="19" ry="15" fill="#E8C87A"/>
    <circle cx="24" cy="31" r="2.8" fill="#C9A84C" opacity="0.65"/>
    <circle cx="39" cy="34" r="2.2" fill="#C9A84C" opacity="0.65"/>
    <circle cx="29" cy="39" r="2"   fill="#C9A84C" opacity="0.65"/>
    <circle cx="28" cy="33" r="2.2" fill="#3D2800"/>
    <circle cx="37" cy="33" r="2.2" fill="#3D2800"/>
    <circle cx="29" cy="32" r="0.8" fill="white"/>
    <circle cx="38" cy="32" r="0.8" fill="white"/>
    <path d="M27 38.5 Q32.5 43 38 38.5" stroke="#3D2800" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
    <path d="M26 19 Q24 14.5 26.5 10" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.7"/>
    <path d="M32 17 Q30 12.5 32.5 8" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.7"/>
    <path d="M38 19 Q40 14.5 37.5 10" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.7"/>
  </svg>
);

export default function Header({ theme, onToggleTheme, onViewProfile, onOpenMealPlanner, onHome, totalXP = 0 }) {
  const { loginWithRedirect, user, isAuthenticated, isLoading } = useAuth0();
  const bmcUrl = process.env.REACT_APP_BMC_URL || 'https://buymeacoffee.com/ohapotato';

  return (
    <header className="app-header">
      {/* Logo */}
      <button style={s.logoBtn} onClick={onHome} aria-label="Go to home"
        onMouseEnter={e => e.currentTarget.querySelector('span').style.color = 'var(--accent-orange)'}
        onMouseLeave={e => e.currentTarget.querySelector('span').style.color = 'var(--text-primary)'}
      >
        <PotatoMark />
        <span style={s.logoText}>
          Oh<span style={s.logoAccent}>a</span>potato
        </span>
      </button>

      {/* Desktop nav */}
      <nav className="nav-links">
        {isAuthenticated && (
          <button style={s.navBtn} onClick={onOpenMealPlanner}
            onMouseEnter={e => { e.currentTarget.style.background='var(--accent-orange)'; e.currentTarget.style.color='#fff'; e.currentTarget.style.borderColor='var(--accent-orange)'; }}
            onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--text-secondary)'; e.currentTarget.style.borderColor='var(--border-base)'; }}
          >🗓️ Meal Planner</button>
        )}
        <Link to="/tips" style={s.navLink}
          onMouseEnter={e => { e.currentTarget.style.background='var(--bg-pill)'; e.currentTarget.style.borderColor='var(--border-strong)'; }}
          onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.borderColor='var(--border-base)'; }}
        >📖 Cooking Tips</Link>
        <a href={bmcUrl} target="_blank" rel="noopener noreferrer" style={s.navLink}
          onMouseEnter={e => { e.currentTarget.style.background='#FFDD00'; e.currentTarget.style.borderColor='#FFDD00'; e.currentTarget.style.color='#000'; }}
          onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.borderColor='var(--border-base)'; e.currentTarget.style.color='var(--text-secondary)'; }}
        >☕ Buy me a coffee</a>
      </nav>

      {/* Right side */}
      <nav className="app-nav">
        {/* XP counter — only shown when there are results */}
        {totalXP > 0 && (
          <span style={s.xpPill} title="Total XP from current recipe results">
            ✦ {totalXP} XP
          </span>
        )}

        {/* Theme toggle */}
        <button onClick={onToggleTheme} style={s.iconBtn} aria-label="Toggle theme"
          title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          onMouseEnter={e => { e.currentTarget.style.background = 'var(--bg-pill)'; e.currentTarget.style.borderColor = 'var(--border-strong)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'var(--border-base)'; }}
        >
          {theme === 'light' ? <MoonIcon /> : <SunIcon />}
          <span className="nav-links" style={{ fontSize:'13px' }}>
            {theme === 'light' ? 'Dark' : 'Light'}
          </span>
        </button>

        {/* Auth */}
        {!isLoading && (
          isAuthenticated && user
            ? <UserMenu user={user} onViewProfile={onViewProfile} />
            : <button style={s.signInBtn} onClick={() => loginWithRedirect()}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--accent-orange-light)'}
                onMouseLeave={e => e.currentTarget.style.background = 'var(--accent-orange)'}
              >Sign in</button>
        )}
      </nav>
    </header>
  );
}

const s = {
  logoBtn: {
    display:'flex', alignItems:'center', gap:'9px',
    background:'none', border:'none', cursor:'pointer',
    padding:'4px 0', borderRadius:'var(--radius-sm)',
    textDecoration:'none', outline:'none', flexShrink:0,
  },
  logoText: {
    fontFamily:'var(--font-display)', fontSize:'19px', fontWeight:'700',
    letterSpacing:'-0.4px', color:'var(--text-primary)',
    transition:'color 0.14s ease', whiteSpace:'nowrap',
  },
  logoAccent: { color:'var(--accent-orange)' },
  navBtn: {
    display:'flex', alignItems:'center', gap:'5px', padding:'6px 13px',
    border:'1px solid var(--border-base)', borderColor:'var(--border-base)',
    borderRadius:'var(--radius-pill)', background:'transparent',
    color:'var(--text-secondary)', cursor:'pointer',
    fontFamily:'var(--font-body)', fontSize:'13px', fontWeight:'500',
    whiteSpace:'nowrap', transition:'all 0.14s ease', outline:'none',
  },
  navLink: {
    display:'flex', alignItems:'center', gap:'5px', padding:'6px 13px',
    border:'1px solid var(--border-base)', borderRadius:'var(--radius-pill)',
    background:'transparent', color:'var(--text-secondary)',
    fontFamily:'var(--font-body)', fontSize:'13px', fontWeight:'500',
    whiteSpace:'nowrap', textDecoration:'none', transition:'all 0.14s ease',
  },
  xpPill: {
    display:'inline-flex', alignItems:'center', gap:'4px',
    padding:'5px 11px', borderRadius:'var(--radius-pill)',
    background:'var(--xp-purple-bg)',
    border:'1px solid var(--xp-purple)',
    color:'var(--xp-purple)',
    fontFamily:'var(--font-body)', fontSize:'12px', fontWeight:'700',
    letterSpacing:'0.3px', whiteSpace:'nowrap',
    animation:'xpPop 0.4s cubic-bezier(0.34,1.56,0.64,1) both',
  },
  iconBtn: {
    display:'flex', alignItems:'center', gap:'6px', padding:'7px 11px',
    minWidth:'36px', minHeight:'36px',
    border:'1px solid var(--border-base)', borderColor:'var(--border-base)',
    borderRadius:'var(--radius-pill)', background:'transparent',
    color:'var(--text-secondary)', cursor:'pointer',
    fontFamily:'var(--font-body)', fontSize:'13px', fontWeight:'400',
    whiteSpace:'nowrap', transition:'background 0.14s ease, border-color 0.14s ease',
    outline:'none',
  },
  signInBtn: {
    marginLeft:'2px', padding:'7px 16px', border:'none',
    borderRadius:'var(--radius-pill)', background:'var(--accent-orange)', color:'#fff',
    cursor:'pointer', fontFamily:'var(--font-body)',
    fontSize:'13px', fontWeight:'500', whiteSpace:'nowrap',
    transition:'background 0.14s ease',
  },
};
